import { Product } from '@deliveries-app/models';
import Metadata from 'pusher-js/types/src/core/channels/metadata';

export enum ProductActionTypes {
  CREATE_PRODUCT_SUCCESS = 'PRODUCTS/CREATE_PRODUCT_SUCCESS',
  CREATE_PRODUCT_FAILURE = 'PRODUCTS/CREATE_PRODUCT_FAILURE',
  GET_ALL_PRODUCTS_SUCCESS = 'PRODUCTS/GET_ALL_PRODUCTS_SUCCESS',
  GET_ALL_PRODUCTS_FAILURE = 'PRODUCTS/GET_ALL_PRODUCTS_FAILURE',
  UPDATE_PRODUCT_SUCCESS = 'PRODUCTS/UPDATE_PRODUCT_SUCCESS',
  UPDATE_PRODUCT_FAILURE = 'PRODUCTS/UPDATE_PRODUCT_FAILURE',
  DELETE_PRODUCT_SUCCESS = 'PRODUCTS/DELETE_PRODUCT_SUCCESS',
  DELETE_PRODUCT_FAILURE = 'PRODUCTS/DELETE_PRODUCT_FAILURE',
}

export type ProductActions =
  | {
      type: ProductActionTypes.GET_ALL_PRODUCTS_SUCCESS;
      payload: {
        data: Product[];
        _metadata: Metadata;
      };
    }
  | {
      type: ProductActionTypes.GET_ALL_PRODUCTS_FAILURE;
      payload: Error;
    }
  | {
      type: ProductActionTypes.CREATE_PRODUCT_SUCCESS;
      payload: Product;
    }
  | {
      type: ProductActionTypes.CREATE_PRODUCT_FAILURE;
      payload: {
        error: Error;
        errors: Error[];
      };
    }
  | {
      type: ProductActionTypes.UPDATE_PRODUCT_SUCCESS;
      payload: Product;
    }
  | {
      type: ProductActionTypes.UPDATE_PRODUCT_FAILURE;
      payload: {
        error: Error;
        errors: Error[];
      };
    }
  | {
      type: ProductActionTypes.DELETE_PRODUCT_SUCCESS;
      payload: string | number;
    }
  | {
      type: ProductActionTypes.DELETE_PRODUCT_FAILURE;
      payload: string | number;
    };
